<template>
	<div>
		<!-- Swap Dialog -->
        <modal
            class="swap-modal"
            size="small-medium"
			@close="close"
			:hide-footer="true">
            <template slot="header">
                <h5 class="mb-0">{{ $t('Warning') }}</h5>
            </template>
            <template slot="body">
				<div class="text-center">
                    <p class="material-icons-copy text-center">error_outline</p>
                </div>
                <p class="mb-2 text-center text-base">{{ $t('The media that you uploaded is already on the list. Try to upload different files to avoid duplication') }},</p>
                <div class="text-center">
                    <button
                        @click="close"
                        type="submit"
                        class="btn btn-submit btn-primary text-center mt-6">
                        {{ $t('Ok') }}
                    </button>
                </div>
            </template>
		</modal>
	</div>
</template>

<script>

import Modal from '@/components/Modal.vue';

export default {
	name: 'ModalAlertSameFileUpload',
	components: {
		Modal,
	},
	props: {},
	mounted() {
	},
	data: () => ({
		isShowModal: false,
	}),
	methods: {
		close() {
			this.$emit('close');
		},
	},
	computed: {
	},
};
</script>

<style lang="scss" scoped>
.material-icons-copy {
    font-family: 'Material Icons';
    position: rela;
    padding: 0px;
    margin: 0px;
    font-size: 60px;
	color: #FFA800;
    line-height: 1;
}
.wrapper-offline{
		text-align: center!important;
	}
</style>
